// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","253":"component---src-templates-card-tsx","691":"component---src-pages-index-tsx","969":"b371cc99641a79dc8c50fa6a11ac9c801301d79b"}[chunkId] + "-" + {"218":"19e3429905b43d89add9","253":"a5dd2b5d144c56f8044a","691":"a402d8444fa79892e2cf","969":"0399cd620c80058b8680"}[chunkId] + ".js";
};